class CartIconBubble extends HTMLElement {
  constructor() {
    super();

    this.cartIcon = this.querySelector('[data-cart-icon-bubble]');
    this.cartNotification = document.getElementById('cart-notification');

    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.cartIcon) {
      this.cartIcon.addEventListener('click', this.toggleCartNotification.bind(this));
    }
  }

  toggleCartNotification(evt) {
    evt.preventDefault();

    if (this.cartNotification.classList.contains('active')) {
      this.closeCartNotification();
    } else {
      this.cartNotification.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('overflow-hidden');
      document.querySelector('[data-cart-notification-bg]').classList.add('active');

      this.setBackgroundInert(true);
      this.activeElement = this.cartIcon;

      window.dispatchEvent(new CustomEvent('cart:opened'));

      // Focus the visible checkout button when the cart has items (button[name="checkout"]
      // is the hidden fallback form button), else the close button.
      const focusTarget = this.cartNotification.querySelector('#checkout')
        || this.cartNotification.querySelector('[data-cart-notification-close]');
      trapFocus(this.cartNotification, focusTarget);

      document.body.addEventListener('click', this.onBodyClick);
    }
  }

  closeCartNotification() {
    this.cartNotification.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    document.querySelector('[data-cart-notification-bg]').classList.remove('active');

    this.setBackgroundInert(false);

    document.body.removeEventListener('click', this.onBodyClick);
    window.dispatchEvent(new CustomEvent('cart:closed'));

    removeTrapFocus(this.activeElement);
  }

  setBackgroundInert(isInert) {
    document.querySelectorAll('#sticky-header, #shopify-section-header, #shopify-section-custom-header, main, #shopify-section-footer').forEach((el) => {
      if (isInert) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    });
  }

  handleBodyClick(evt) {
    // This listener outlives closes initiated elsewhere (Escape, close button);
    // ignore clicks once the drawer is no longer open.
    if (!this.cartNotification.classList.contains('active')) return;

    const target = evt.target;
    if (target !== this.cartNotification && !target.closest('cart-notification') && !target.closest('cart-icon-bubble')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : this.cartIcon;
      this.closeCartNotification();
    }
  }
}

customElements.define('cart-icon-bubble', CartIconBubble);
